import React from "react"
import { Switch, Route } from "react-router-dom"
// import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import {
	ROUTES,
} from "components/routes"
import PageNotFound from "components/page-not-found"

class AppBody extends React.Component {

  render() {
  	const {page} = this.props
    return (
    	<Switch>
    		{ROUTES.length && ROUTES.map((route, key) => {
    			const {Component} = route
    			return (
	    			<Route
	    				key={`route-component-${route-key}`}
	    				exact={route.exact || false}
	    				path={route.pathname}
	    				component={() => <Component page={page}/>}/>
	    		)
	    	})}

    		<Route component={PageNotFound} />
      </Switch>
    )
  }
}

export default withRouter(AppBody)